<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        title="医師プロフィール"
        ok-only
        ok-title="閉じる"
        ok-variant="yokumiru-gray"
        @ok="close"
        @hidden="close">
        <div>
            <div
                v-if="doctor !== null"
                class="p-2">
                <doctor-info
                    :doctor="doctor"
                    :user="user"
                    :early-schedule="earlyScheduleComputed"
                    doctor-introduction-type="all">
                </doctor-info>
                <user-reservation-doctor-menu
                    v-if="canReserve"
                    :doctor-menus="doctor.doctor_menus"
                    is-grouped>
                </user-reservation-doctor-menu>
            </div>
            <div
                v-else
                class="d-flex justify-content-center align-items-center">
                <b-spinner variant="yokumiru-user"/>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import constants from '../../../constants'
    import {mapMutations} from "vuex";

    export default {
        props: {
            user: {
                type: Object,
                default: null,
            },
        },

        data: function() {
            return {
                doctor: null,
                modalShow: false,
                earlySchedule: null,
                canReserve: false,
            }
        },

        computed: {
            earlyScheduleComputed: function () {
                if (this.earlySchedule !== null) {
                    return this.earlySchedule
                }
                if (!this.doctor || this.doctor.doctor_menus.length < 1) {
                    return null
                }

                // 相談時間が最も短いメニューから最短予約可能時間を判断する
                const doctorMenus = [...this.doctor.doctor_menus]
                const menu = doctorMenus.sort((a, b) => {
                    if (a.consultation_minutes < b.consultation_minutes) return -1
                    if (a.consultation_minutes > b.consultation_minutes) return 1
                    return 0
                })
                return menu[0].early_schedule
            },
        },

        created: function() {
            bus.$on('open-modal-doctor-profile', this.open)
            bus.$on('close-modal-doctor-profile', this.close)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-doctor-profile')
            bus.$off('close-modal-doctor-profile')
        },

        methods: {
            ...mapMutations({
                setUser: 'reservation/setUser',
            }),

            open: async function (doctorId, options = {}) {
                this.fetchDoctor(doctorId)
                this.earlySchedule = options.earlySchedule || null
                this.canReserve = options.canReserve || false

                if (this.canReserve) {
                    this.setUser(this.user)
                }
                this.modalShow = true
            },

            close: function () {
                this.modalShow = false
                this.doctor = null
            },

            /**
             * 医師詳細を取得
             * @param {number} doctorId
             */
            fetchDoctor: function (doctorId) {
                this.doctor = null
                const endpoint = `${constants.user.doctors.endpoint.base}/${doctorId}`

                axios.get(endpoint).then(({data}) => {
                    this.doctor = data.data
                })
            },
        }
    }
</script>
